import {
  WorkspaceAddModeDialog,
  type WorkspaceAddMode,
} from "@/action-dialog/dialogs/WorkspaceAddModeDialog";
import { setAlwaysAddAsReference } from "@/action-dialog/workspaceAddModePreference";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type WorkspaceAddModeCallableProps = {
  count: number;
  /** Shown when count === 1. */
  fileName?: string;
  destination: "canvas" | "chat";
};

/** Resolves with the chosen mode, or null when dismissed. */
export const WorkspaceAddModeCallable = createCallable<
  WorkspaceAddModeCallableProps,
  WorkspaceAddMode | null
>(
  ({ call, count, fileName, destination }) => (
    <WorkspaceAddModeDialog
      count={count}
      fileName={fileName}
      destination={destination}
      onChoose={(choice, { alwaysReference }) => {
        // Persist on confirm (either verb — the preference governs the
        // NEXT pick), never on dismiss.
        if (alwaysReference) setAlwaysAddAsReference();
        call.end(choice);
      }}
      onClose={() => call.end(null)}
    />
  ),
  UNMOUNTING_DELAY_MS,
);

WorkspaceAddModeCallable.displayName = "WorkspaceAddModeCallable";
